import { render, staticRenderFns } from "./DayNoteEditorDialog.vue?vue&type=template&id=378203a4&"
import script from "./DayNoteEditorDialog.vue?vue&type=script&lang=js&"
export * from "./DayNoteEditorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports